import { useState, useEffect } from 'react';
import api from '../../services/api';
import { Header } from '../../components/Header';
import { Select, Options } from '../../components/Select';
import { Sidebar } from '../../components/Sidebar';
import { Main } from '../../components/Main';
import { CardContent } from '../../components/CardContent';
import { Text } from '../../components/Text';
import { Button, Col, Row, Modal, FormGroup } from 'react-bootstrap';
import { Subtitle } from '../../components/SubTitle';
import { Table, TBody, TCell, TGroup, THeader, TRow, ThCell } from '../../components/Table/Table';
import { FillPen } from '../../components/Icons';
import { Title } from '../../components/Title';
import './style.css';
import AlertMessage from '../../components/Alert';
import { Label } from '../../components/Label';
import { Box } from '@mui/material';
import { Modal as MaterialModal } from '@mui/material';
import { DeleteModal } from '../../components/ModalDelete';

export function CadastrarConograma() {
    // Estado para armazenar as ações do cronograma
    const [acoes, setAcoes] = useState([]);
    const [acaoSelecionada, setAcaoSelecionada]: any = useState([]);
    const [novaAcao, setNovaAcao] = useState({ nome: '', responsavel: '', dataExecucao: '' });
    const [intervalosCronograma, setIntervalosCronograma] = useState<any[]>([]);
    const [execucoesCronograma, setExecucoesCronograma]: any = useState([]);
    const [alerts, setAlert] = useState({ show: false, message: '', variant: 'success' });
    const [showTable, setShowTable] = useState(false);
    const [showAlert, setShowAlert] = useState(false);
    const [docType, setDocType] = useState('');
    const [nome, setNome] = useState('');
    const [showHelpModal, setShowHelpModal] = useState(false);
    const [acaoId, setAcaoId] = useState('');
    const [mesesSelecionados, setMesesSelecionados]: any = useState({});
    const [responsavel, setResponsavel]: any = useState('');
    const [responsavelEditado, setResponsavelEditado]: any = useState('');
    const [key, setKey]: any = useState('');
    const [nomeEditado, setNomeEditado]: any = useState('');
    const [editMode, setEditMode] = useState(false);

    useEffect(() => {
        listarAcoes();
    }, []);

    const handleCheckboxChange = (mes: number) => {
        setMesesSelecionados((prevState: { [x: string]: any; }) => ({
            ...prevState,
            [mes]: !prevState[mes]
        }));
    };
    const handleCheckboxEdit = (id_intervalo_execucoes: string | number) => {
        setMesesSelecionados((prevState: { [x: string]: any; }) => ({
            ...prevState,
            [id_intervalo_execucoes]: !prevState[id_intervalo_execucoes]
        }));
    };


    const salvarPadrao = async () => {
        const indicesMeses = Array.from({ length: 12 }, (_, i) => i + 1);

        const execucoes = indicesMeses.map(mes => ({
            id_intervalo_execucoes: mes,
            executada: mesesSelecionados[mes] ? 1 : 0,
            tipo_documento: docType,
            nome,
            responsavel: responsavel
        }));

        try {
            await api.post('salvar-cronograma-padrao', execucoes);

            setAlert({ message: 'Cronograma criado com sucesso!', variant: 'success', show: true })

        } catch (error: any) {
            console.log(error.message);
        }

        setMesesSelecionados({});
        setNome('');
        setDocType('');
        setKey('');
        setResponsavel('');
        listarAcoes();
        setShowTable(false);

    };

    const handleSelectTipoDoc = (type: any) => {
        setDocType(type);
        setKey('teste');
    };

    const listarAcoes = async () => {
        try {
            const response = await api.get('listar-acoes-cadastradas')
            setAcoes(response.data)

        } catch (error) {
            console.log(error)
        }
    }

    const showCronograma = () => {
        if (!nome && docType) {
            setAlert({ message: 'Campo NOME está vazio!', variant: 'danger', show: true })
        } else if (nome && !docType) {
            setAlert({ message: 'Selecione o tipo de documento do Cronograma!', variant: 'danger', show: true })
        } else if (nome && docType) {
            setShowTable(true);
        } else {
            setAlert({ message: 'Preencha/Selecione os campos vazios!', variant: 'danger', show: true })
        }
    }

    const handleCloseHelpModal = () => {
        setShowHelpModal(false);
    };

    const handleDeleteConfirm = async (idFuncao: number) => {
        await listarAcoes();
    };

    const handleEditClick = async (acao: any) => {
        setAcaoId(acao);
        try {
            const response = await api.post(`listar-cronograma/${acao}`);
            setAcaoSelecionada(response.data);

            const initialCheckStates: any = {};
            response.data.execucoes.forEach((execucao: { id_intervalo_execucoes: string | number; executada: any; }) => {
                initialCheckStates[execucao.id_intervalo_execucoes] = !!execucao.executada;
            });
            setMesesSelecionados(initialCheckStates);
            setResponsavelEditado(response.data.acoes && response.data.acoes.length > 0 ? response.data.acoes[0].responsavel : '');
            setNomeEditado(response.data.acoes && response.data.acoes.length > 0 ? response.data.acoes[0].descricao : '');
        } catch (error) {
            console.log(error);
        } finally {
            setEditMode(true);
        }
    };

    const salvarAlteracoes = async (acao: any) => {
        const payload = Object.keys(mesesSelecionados).map(key => ({
            id_intervalo_execucoes: key,
            executada: mesesSelecionados[key] ? 1 : 0,
            nome: nomeEditado,
            responsavel: responsavelEditado,
            id_acoes_cronograma: acao
        }));

        try {
            const response = await api.post('editar-cronograma', payload);

            if (response.status == 204) {
                setAlert({ message: 'Cronograma atualizado com sucesso!', variant: 'success', show: true })
                setEditMode(false)
            }

        } catch (error) {
            console.error("Error saving changes:", error);
        } finally {
            listarAcoes()
        }
    };

    return (
        <>
            <Sidebar />
            <Header route='./' />
            <Main>
                <div className=''>
                    <CardContent>
                        <div className='d-flex' style={{ width: '100%' }}>
                            <Text text="Documento do Cronograma" />
                            <Select width="600px" id='empresas' key={key} value={docType} onSelect={handleSelectTipoDoc}>
                                <Options value={'PGR'} name='PGR' />
                                <Options value={'PCMSO'} name='PCMSO' />
                            </Select>
                        </div>
                    </CardContent>
                    <CardContent>

                        <>
                            {docType ? (
                                <Title text={`Cronograma de Ação Padrão (${docType})`} />
                            ) : (
                                <Title text={`Cronograma de Ação Padrão`} />
                            )}

                            <Subtitle text="Inserir Nova Ação Padronizada" />
                            <Row>
                                <Col md={6}>
                                    <FormGroup className={`form-group-dsg`}>
                                        <Label title="NOME" htmlFor="nomeAcao" />
                                        <input type="text" id="nomeAcao" name="nome" style={{ width: "100%" }} value={nome} onChange={(e) => setNome(e.target.value)} />
                                    </FormGroup>
                                </Col>
                                <Col md={5}>
                                    <FormGroup className='form-group-dsg'>
                                        <Label title="RESPONSÁVEL" htmlFor="respAcao" />
                                        <input type="text" id="respAcao" name="responsavel" style={{ width: "100%" }} value={responsavel} onChange={(e) => setResponsavel(e.target.value)} />
                                    </FormGroup>
                                </Col>

                                <Col md={1}>
                                    <div className="d-grid justify-content-center">
                                        &nbsp;
                                        <Button variant='success' onClick={showCronograma}>
                                            Adicionar
                                        </Button>
                                    </div>
                                </Col>
                            </Row>
                            <Row>

                            </Row>
                        </>


                        {showTable == true && (
                            <>
                                <Row className='acao-planejada mt-4'>
                                    <Col md={12}>
                                        <Table>
                                            <THeader>
                                                <ThCell>Ação Planejada</ThCell>
                                                {Array.from({ length: 12 }, (_, i) => (
                                                    <ThCell key={i}>Mês {i + 1}</ThCell>
                                                ))}
                                            </THeader>
                                            <TBody className='table-row-cronograma'>
                                                <TRow>
                                                    <TCell>{nome}</TCell>
                                                    {Array.from({ length: 12 }, (_, i) => (
                                                        <TCell key={i}>
                                                            <input
                                                                type="checkbox"
                                                                checked={!!mesesSelecionados[i + 1]}
                                                                onChange={() => handleCheckboxChange(i + 1)}
                                                            />
                                                        </TCell>
                                                    ))}
                                                </TRow>
                                            </TBody>
                                        </Table>

                                    </Col>
                                </Row>
                                <Row style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
                                    <Button style={{ width: '10%' }} onClick={salvarPadrao}>
                                        Salvar Padrão
                                    </Button>

                                </Row>
                            </>
                        )}
                    </CardContent>
                    <CardContent>
                        <Row className='my-4'>
                            <Box sx={{
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                width: '100%'
                            }}>
                                <Title text="Ações Cadastradas" />
                            </Box>
                        </Row>
                        <Row className='mb-4'>
                        </Row>
                        <Row>
                            <Col md={12}>
                                <div style={{ border: '1px solid #007bff', borderRadius: '6px', overflow: 'hidden', marginTop: '30px' }}>
                                    <div style={{ overflow: 'auto' }}>
                                        <table className="table-row-cronograma-listagem" style={{ width: '100%', borderCollapse: 'collapse' }}>
                                            <thead>
                                                <tr style={{ backgroundColor: '#007bff', color: 'white', textAlign: 'center' }}>
                                                    <th style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid white', fontSize: '13px', fontWeight: 'normal', flex: '5% !important' }}>ID</th>
                                                    <th style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid white', fontSize: '13px', fontWeight: 'normal' }}>Nome</th>
                                                    <th style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid white', fontSize: '13px', fontWeight: 'normal' }}>Responsável</th>
                                                    <th style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid white', fontSize: '13px', fontWeight: 'normal' }}>Tipo de Documento</th>
                                                    <th style={{ padding: '15px', textAlign: 'center', fontSize: '13px', fontWeight: 'normal' }}>Ação</th>
                                                </tr>
                                            </thead>
                                            <tbody className='table-row-cronograma-listagem'>
                                                {acoes.map((acao: any, index: number) => (
                                                    <tr key={index} style={{ textAlign: 'center' }}>
                                                        <td style={{
                                                            width: '50px', padding: '15px', borderRight: '1px solid lightgray',
                                                            borderTop: '1px solid lightgray', fontSize: '13px', fontWeight: 'normal'
                                                        }}>
                                                            {acao.id}
                                                        </td>
                                                        <td style={{ padding: '15px', borderRight: '1px solid lightgray', borderTop: '1px solid lightgray', fontSize: '13px', fontWeight: 'normal' }}>
                                                            {acao.descricao}
                                                        </td>
                                                        <td style={{ padding: '15px', borderRight: '1px solid lightgray', borderTop: '1px solid lightgray', fontSize: '13px', fontWeight: 'normal' }}>
                                                            {acao.responsavel ? acao.responsavel : 'Não Identificado'}
                                                        </td>
                                                        <td style={{ padding: '15px', borderRight: '1px solid lightgray', borderTop: '1px solid lightgray', fontSize: '13px', fontWeight: 'normal' }}>
                                                            {acao.tipo_documento}
                                                        </td>
                                                        <td style={{ padding: '15px', display: 'flex', justifyContent: 'center', borderTop: '1px solid lightgray', gap: '10px' }}>
                                                            <Button
                                                                variant='outline-primary'
                                                                className='btn-outline-main'
                                                                onClick={() => handleEditClick(acao.id)}
                                                                style={{ fontSize: '13px' }}>
                                                                Editar
                                                                <FillPen />
                                                            </Button>
                                                            <DeleteModal
                                                                endpoint='excluir-cronograma-padrao'
                                                                onConfirm={handleDeleteConfirm}
                                                                requestBody={{ id: acao.id }}
                                                            />
                                                        </td>
                                                    </tr>
                                                ))}
                                                {acoes.length === 0 && (
                                                    <tr>
                                                        <td colSpan={5} style={{ padding: '15px', textAlign: 'center', fontSize: '13px', fontWeight: 'normal' }}>
                                                            Não há dados para serem mostrados
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </CardContent>
                    <AlertMessage
                        show={alerts.show}
                        message={alerts.message}
                        variant={alerts.variant}
                        onClose={() => setAlert({ ...alerts, show: false })} />
                    <Modal size='xl' show={editMode} onHide={() => setEditMode(false)} style={{ width: '100%' }}>
                        <Modal.Header closeButton>
                            <b>Editar Cronograma</b>
                        </Modal.Header>
                        <Modal.Body>
                            <Row className='acao-planejada mt-4'>
                                <Col md={12}>
                                    <Table>
                                        <THeader>
                                            <ThCell>Ação Planejada</ThCell>
                                            {Array.from({ length: 12 }, (_, i) => (
                                                <ThCell key={i}>Mês {i + 1}</ThCell>
                                            ))}
                                        </THeader>
                                        <TBody>
                                            <TRow>
                                                <TCell>
                                                    <input type="text" id="respAcao" name="nome" style={{ width: "100%", border: 'none' }} value={nomeEditado} onChange={(e) => setNomeEditado(e.target.value)} />
                                                </TCell>
                                                {acaoSelecionada.execucoes && acaoSelecionada.execucoes.map((acao: { id_intervalo_execucoes: number; }, index: any) => (
                                                    <TCell key={index}>
                                                        <input
                                                            type="checkbox"
                                                            checked={mesesSelecionados[acao.id_intervalo_execucoes] || false}
                                                            onChange={() => handleCheckboxChange(acao.id_intervalo_execucoes)}
                                                        />
                                                    </TCell>
                                                ))}
                                            </TRow>
                                            <TRow>
                                                <Label title="Responsável" htmlFor="nomeAcao" />
                                                <input type="text" id="respAcao" name="responsavel" style={{ width: "25%", borderWidth: 0.5, borderColor: '#EFEFEF' }} value={responsavelEditado} onChange={(e) => setResponsavelEditado(e.target.value)} />
                                            </TRow>
                                        </TBody>
                                    </Table>
                                </Col>
                            </Row>
                        </Modal.Body>
                        <Modal.Footer style={{ width: '100%' }}>
                            <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
                                {/* <Button variant="success" onClick={(e) => handleSubmitRisk(e, idRisco)} style={{ marginRight: '10px' }}> */}
                                <Button variant="success" style={{ marginRight: '10px' }} onClick={() => salvarAlteracoes(acaoId)}>
                                    Salvar
                                </Button>
                                <Button variant="danger" style={{ marginRight: '10px' }} onClick={() => setEditMode(false)}>
                                    Cancelar
                                </Button>
                            </Box>
                        </Modal.Footer>
                    </Modal>
                </div>
            </Main></>
    );
}
